export const API_PROFILE_HEADER = 'X-API-PROFILE';
